export default __webpack_public_path__ + "static/media/oil-rig.17108884.svg";